var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.masterList,"item-text":"label","item-value":_vm.itemValue,"clearable":_vm.clearable,"label":"削除区分","error-messages":_vm.errorHandlerMethod(_vm.errorHandlerMethodArgComputed)},model:{value:(_vm.p_code),callback:function ($$v) {_vm.p_code=$$v},expression:"p_code"}})
}
var staticRenderFns = []

export { render, staticRenderFns }